import React, { ReactElement } from 'react';
import classes from './TableHeaderWrapper.module.scss';
import { useDebouncedCallback } from 'use-debounce';
import { WMSearchFilter } from '@walkme/wm-ui';
import { useTranslation } from 'react-i18next';

const keyPrefix = 'components.appTable.tableHeaderWrapper';

const TableHeaderWrapper = ({
    searchTerm = '',
    onSearchTermChange,
    tableDataTestid,
    debounceDuration = 300,
    tableName,
    disabled
}: {
    searchTerm?: string;
    onSearchTermChange?: (searchTerm: string) => void;
    tableDataTestid?: string;
    debounceDuration?: number;
    tableName?: string | ReactElement;
    disabled?: boolean;
}) => {
    const { t } = useTranslation('', { keyPrefix });
    const debouncedSearch = useDebouncedCallback((searchTerm: string) => {
        onSearchTermChange?.(searchTerm);
    }, debounceDuration);

    return (
        <div className={classes.tableHeaderContainer}>
            <div className={classes.tableHeader}>
                <span className={classes.tableName}>{tableName}</span>

                <div className={classes.searchWrapper}>
                    <WMSearchFilter
                        ds2
                        className={classes.wmSearchFilter}
                        data-testid={`${tableDataTestid}-search-panel`}
                        value={searchTerm}
                        onSearch={debouncedSearch}
                        disabled={disabled}
                        placeholder={t('search')}
                    />
                </div>
            </div>
        </div>
    );
};

export default TableHeaderWrapper;
